import React, { useState, useContext,useEffect } from "react";
import BikeCard from "./BikeCard";
import { useSelector } from "react-redux";
import { SelectionContext } from "../../Context/SelectionContextProvider";

import styles from "./Tarrif.module.css";
import Search from "../Search/Search";

function Tarrif() {
  const allBikes = useSelector((state) => {
    const bikes = state?.tarrifReducer?.allBikes;
    const result = bikes.filter((bike, index, self) =>
      index === self.findIndex((t) => ( t.bike_name === bike.bike_name))
    ); 
    return result;
  });

  const [modalOpen, setModalOpen] = useState(false);
  const { selectedBikeHandler } = useContext(SelectionContext);

  const bookNowHandler = (payload) => {
    setModalOpen(true);
    selectedBikeHandler(payload);
  };
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  console.log(allBikes, 'allBikes')
  return (
    <div className={styles.Tarrif}>
      <Search modalOpen={modalOpen} setModalOpen={setModalOpen}></Search>
      <h1>Bike rental tariffs</h1>
      <div className={styles.Tarrif__bikes}>
        {allBikes?.map((item) => (
          <BikeCard
            bookNowHandler={bookNowHandler}
            key={item._id}
            {...item}
          ></BikeCard>
        ))}
      </div>
    </div>
  );
}

export default Tarrif;
